import { getMostAlignedSdgs } from '@upright/common/model/output/scores/sdg-alignment/utils';
import { Valence } from '@upright/common/model/types';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { valenceToSide } from '@upright/ui/common/upright/core/impact-lens-profile/common/utils';
import { useCarouselLayout } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { sdgLensLayout } from '@upright/ui/common/upright/core/impact-lenses/sdg/common/layout';
import { useSdgLensContext } from '@upright/ui/common/upright/core/impact-lenses/sdg/common/use-sdg-lens-context';
import { toSdgAligmentValence } from '@upright/ui/common/upright/core/impact-lenses/sdg/common/utils';
import { useSdgUnitsMode } from '@upright/ui/common/upright/model/output/scores/sdg-alignments/use-sdg-unit-mode';
import styled from 'styled-components';

interface Props {
  valence: Valence;
}

export function SdgTitleForValence(props: Props) {
  const ctx = useSdgLensContext();
  const baseLayout = useCarouselLayout();
  const [unitsMode] = useSdgUnitsMode();
  if (!ctx) {
    return <></>;
  }
  const data = ctx.data.sdgAlignments;
  if (!data) {
    return <></>;
  }
  const layout = sdgLensLayout(baseLayout, data, unitsMode);
  const text = props.valence === Valence.POSITIVE ? 'aligned' : 'misaligned';
  const sdgIds = getMostAlignedSdgs(data, toSdgAligmentValence(props.valence), false);

  if (sdgIds.length === 0) {
    return <></>;
  }

  const area = layout.sdgBoxArea(valenceToSide(props.valence), sdgIds[0]);
  const textX = props.valence === Valence.POSITIVE ? area.x1 : area.x2;
  const textAnchor = props.valence === Valence.POSITIVE ? 'start' : 'end';

  const fullWidth = baseLayout.fullArea().width;
  if (fullWidth > 950) {
    return (
      <Text x={textX} y={area.y1} textAnchor={textAnchor} dy="-1.5em">
        Most {text} UN Sustainable Development Goals
      </Text>
    );
  } else if (!layout.narrowMode) {
    return (
      <Text x={textX} y={area.y1} textAnchor={textAnchor} dy="-1.5em">
        Most {text} UN SDGs
      </Text>
    );
  } else {
    return (
      <>
        <Text x={textX} y={area.y1} textAnchor={textAnchor} dy={`${-1.5 - 1.4 * 2}em`}>
          Most
        </Text>
        <Text x={textX} y={area.y1} textAnchor={textAnchor} dy={`${-1.5 - 1.4}em`}>
          {text}
        </Text>
        <Text x={textX} y={area.y1} textAnchor={textAnchor} dy={`${-1.5}em`}>
          UN SDGs:
        </Text>
      </>
    );
  }
}

const Text = styled.text`
  fill: ${BouColor.BLACK};
  font-size: 12px;
  font-style: italic;
  font-weight: 500;
`;
